import { gql } from 'apollo-boost';

export const GET_ADMIN_VIDEO_FRAME_ANALYSIS_DEBUG = gql`
    query GetAdminVideoFrameAnalysisDebug($data: GetAdminVideoFrameAnalysisDebugInput) {
        getAdminVideoFrameAnalysisDebug(data: $data) {
            filters {
                limit
                status
                userId
                messageId
                sharedMediaAssetId
                samplingProfile
                staleOnly
            }
            summary {
                total
                pending
                processing
                completed
                failed
                staleProcessing
                recent24h
                completed24h
                failed24h
                averageAttempts
                totalSelectedFrames
                totalSampledFrames
                statusCounts {
                    value
                    count
                }
                samplingProfileCounts {
                    value
                    count
                }
            }
            jobs {
                id
                sharedMediaAssetId
                mediaS3Key
                samplingProfile
                analyzerVersion
                analyzerProvider
                analyzerModel
                status
                attempts
                durationSeconds
                sampledFrameCount
                selectedFrameCount
                contactSheetS3Key
                contactSheetSignedUrl
                manifestS3Key
                combinedOcrText
                errorMessage
                lockExpiresAt
                nextRetryAt
                completedAt
                createdAt
                updatedAt
                ageSeconds
                lockedSeconds
                selectedFrames {
                    timestampSeconds
                    reason
                    frameS3Key
                    frameSignedUrl
                    ocrText
                }
                references {
                    messageId
                    userId
                    title
                    sourceUrl
                }
            }
        }
    }
`;
